import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

// Module-level singleton so the engine is only initialized once per page load
let engineInitPromise = null;

const CONFIGS = {
  fire: {
    fullScreen: { enable: false },
    background: { color: { value: 'transparent' } },
    pauseOnBlur: false,
    fpsLimit: 60,
    particles: {
      number: { value: 120, density: { enable: true } },
      color: { value: ['#ff1a00', '#ff4500', '#ff6a00', '#ff8c00', '#ffb300', '#ffd200', '#fff0a0'] },
      shape: { type: 'circle' },
      opacity: {
        value: { min: 0.02, max: 0.7 },
        animation: { enable: true, speed: { min: 1, max: 3 }, sync: false, startValue: 'random' },
      },
      size: {
        value: { min: 1, max: 9 },
        animation: { enable: true, speed: { min: 2, max: 5 }, sync: false, startValue: 'random' },
      },
      move: {
        enable: true,
        speed: { min: 1.5, max: 4.5 },
        direction: 'top',
        random: true,
        straight: false,
        outModes: { default: 'out' },
        wander: { enable: true, distance: 6, delay: 0.3, speed: { angle: 5 } },
      },
    },
    detectRetina: true,
  },

  stars: {
    fullScreen: { enable: false },
    background: { color: { value: 'transparent' } },
    pauseOnBlur: false,
    fpsLimit: 30,
    particles: {
      number: { value: 200, density: { enable: false } },
      color: { value: ['#ffffff', '#e8f4ff', '#c8dfff', '#eedeff', '#fff5e0', '#b0d8ff'] },
      shape: { type: 'circle' },
      opacity: {
        value: { min: 0.08, max: 1.0 },
        animation: { enable: true, speed: { min: 0.2, max: 1.4 }, sync: false, startValue: 'random' },
      },
      size: { value: { min: 0.4, max: 2.6 } },
      move: {
        enable: true,
        speed: 0.04,
        direction: 'none',
        random: true,
        straight: false,
        outModes: { default: 'out' },
      },
    },
    detectRetina: false,
  },

  confetti: {
    fullScreen: { enable: false },
    background: { color: { value: 'transparent' } },
    pauseOnBlur: false,
    fpsLimit: 60,
    particles: {
      number: { value: 45 },
      color: { value: ['#ff5f1f', '#ffd200', '#00d4ff', '#a855f7', '#22c55e', '#f9a8d4'] },
      shape: { type: ['square', 'circle'] },
      opacity: { value: { min: 0.3, max: 0.9 } },
      size: { value: { min: 4, max: 9 } },
      rotate: { value: { min: 0, max: 360 }, animation: { enable: true, speed: 8 } },
      move: {
        enable: true,
        speed: { min: 1, max: 2.5 },
        direction: 'bottom',
        random: true,
        outModes: { default: 'out' },
      },
    },
    detectRetina: true,
  },
};

const ParticlesBg = ({ preset }) => {
  const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    if (!engineInitPromise) {
      engineInitPromise = initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      });
    }
    engineInitPromise.then(() => setEngineReady(true));
  }, []);

  const config = CONFIGS[preset];
  if (!config || !engineReady) return null;

  return (
    <Particles
      id={`particles-bg-${preset}`}
      options={config}
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
      }}
    />
  );
};

export default ParticlesBg;
